module.exports = __webpack_public_path__ + "static/media/logo.9aa957f6.png";